import type { Entry, IElementNbnOrderSummary } from '@belong/types';
import { FMoleculeRichText, FMoleculeText, IEntryMoleculeRichText, IEntryMoleculeText } from '../molecules';
import { parseFlexibleContent } from '../parseFlexibleContent';
import { FElementPromoCodeModalComponent } from './elementPromoCodeModalComponent.factory';

interface IEntryElementNbnOrderSummary {
  addressChangeAriaLabel: string;
  addressChangeLabel: string;
  addressLabel: string;
  explicitPromoHeading: Entry<IEntryMoleculeText>;
  explicitPromos?: Entry<IEntryMoleculeRichText>[];
  fibreUpgradeCostLabel: Entry<IEntryMoleculeText>;
  fibreUpgradeDescriptionLabel: Entry<IEntryMoleculeText>;
  fibreUpgradeHeadingLabel: Entry<IEntryMoleculeText>;
  freeModemDescription?: string;
  freeModemValueText?: string;
  implicitPromoDescription: Entry<IEntryMoleculeText>;
  implicitPromoHeading: Entry<IEntryMoleculeText>;
  modemByoDescription: string;
  modemByoLabel: string;
  modemCostDescriptionMonthly?: string;
  modemCostDescriptionUpfront: string;
  modemCostLabel: string;
  monthlyCostDescription?: string;
  monthlyCostLabel: string;
  ndcCostDescriptionMonthly: string;
  ndcCostDescriptionUpfront?: string;
  ndcCostLabel: string;
  orderHeading: string;
  paidTodayLabel: string;
  planChangeAriaLabel: string;
  planChangeLabel: string;
  planDescription: string;
  planLabel: string;
  preAuthorisationText: string;
  promoCodeModal: Entry<any>;
  promoCodeModalTriggerLabel: string;
  promoCodeRemoveLabel: string;
}

export const FElementNbnOrderSummary = (data: Entry<IEntryElementNbnOrderSummary>): IElementNbnOrderSummary => {
  const { fields } = data;
  const {
    promoCodeModal,
    promoCodeModalTriggerLabel,
    fibreUpgradeCostLabel,
    fibreUpgradeDescriptionLabel,
    fibreUpgradeHeadingLabel,
    implicitPromoDescription,
    implicitPromoHeading,
    explicitPromoHeading,
    explicitPromos = [],
    ...otherFields
  } = fields;

  return {
    ...otherFields,
    explicitPromoHeading: FMoleculeText(explicitPromoHeading),
    explicitPromos: parseFlexibleContent(
      explicitPromos,
      new Map([['moleculeRichText', { factory: FMoleculeRichText }]])
    ),
    fibreUpgradeCost: FMoleculeText(fibreUpgradeCostLabel),
    fibreUpgradeDescription: FMoleculeText(fibreUpgradeDescriptionLabel),
    fibreUpgradeHeading: FMoleculeText(fibreUpgradeHeadingLabel),
    implicitPromoDescription: implicitPromoDescription && FMoleculeText(implicitPromoDescription),
    implicitPromoHeading: implicitPromoHeading && FMoleculeText(implicitPromoHeading),
    promoCodeModalComponent: FElementPromoCodeModalComponent(promoCodeModal),
    promoCodeModalLabel: promoCodeModalTriggerLabel
  };
};
